import { Controller } from "stimulus"
import { contactTemplate, facilitatorTemplate } from '../../js/guestlist_templates';
import { getOrdinalSuffix, getWeekOfTheMonth } from '../../js/date_helpers';
import { RRule } from 'rrule';
import { DataTable } from "simple-datatables";
import Clipboard from 'clipboard';

export default class extends Controller {
  static targets = ["contactList", "facilitatorList", "form", "submit", "timePicker", "startDate", "contacts", "updateSeries", "updateSeriesCheckbox", "frequency"]

  initialize() {
    this.contacts = [];
    this.facilitators = [];
    // Set edit scheduled session variables
    this.scheduledSessionDetails = JSON.parse(document.getElementById('javascript_variables').dataset.scheduledSessionDetails)
    this.sessionTime = this.scheduledSessionDetails.start_time;
    this.savedContacts = this.scheduledSessionDetails.contacts || [];
    console.log(this.scheduledSessionDetails)
    const recordSessionCheckbox = document.getElementById('recordSession');
    if (recordSessionCheckbox) {
      recordSessionCheckbox.checked = this.scheduledSessionDetails.record;
    }
    document.getElementById('muteGuests').checked = this.scheduledSessionDetails.start_muted
    this.rrule = this.scheduledSessionDetails.rrule;
    this.rruleChanged = false;
    this.recurring = this.scheduledSessionDetails.recurring;
    this.timezone = document.getElementById('javascript_variables').dataset.timezone;
    // validations
    this.createScheduledSessionForm = this.createScheduledSessionForm();
    // Setup form
    this.setModalInputsAutofocus();
    this.setTimePickerOptions();
    this.setFrequencyOptions(true);
    // Setup add guest and facilitator modals
    this.facilitatorDataTable = new DataTable("#addFacilitatorTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No contacts found",
        info: "Showing {start} to {end} of {rows} contacts"
      }
    });
    this.guestDataTable = new DataTable("#addGuestTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No contacts found",
        info: "Showing {start} to {end} of {rows} contacts"
      }
    });
    this.setupDataTableSearch();
    this.addGuestJoiningOptionsEventListener();
    this.addFacilitatorJoiningOptionsEventListener();
    this.loadScheduledSessionParticipants();
    this.setupClipboard();
  }

  setupClipboard() {
    var notyf = new Notyf( {
      position: {
      x: 'right',
      y: 'top',
    }
  });
  
    const clipboard = new Clipboard('.btnclipboard');  
    clipboard.on('success', (e) => {
      notyf.success('Copied to clipboard');
      e.clearSelection();
    });
  
    clipboard.on('error', (e) => {
      notyf.error('Failed to copy to clipboard');
    });
  }

  setupDataTableSearch() {
    let facilitatorSearchBar = document.getElementById('addFacilitatorSearchBar');
    facilitatorSearchBar.addEventListener('keyup', (e) => {
      let addFacilitatorTableSearch = document.getElementsByClassName('dataTable-input')[0];
      addFacilitatorTableSearch.value = facilitatorSearchBar.value;
      addFacilitatorTableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
    let guestSearchBar = document.getElementById('addGuestSearchBar');
    guestSearchBar.addEventListener('keyup', (e) => {
      let addGuestTableSearch = document.getElementsByClassName('dataTable-input')[1];
      addGuestTableSearch.value = guestSearchBar.value;
      addGuestTableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }

  addGuestJoiningOptionsEventListener() {
    let guestJoiningOptionsModal = document.getElementById('addGuestStep2Modal');
    guestJoiningOptionsModal.addEventListener('shown.bs.modal', function (event) {
      let button = event.relatedTarget
      let contactData = button.getAttribute('data-bs-guest')
      let data = JSON.parse(contactData);
      document.getElementById('joiningMethodSubtitle').innerHTML = 'Joining method for ' + data.name;
      document.getElementById('addGuest').setAttribute('data-value', contactData)
      document.getElementById('radioInput3').focus();
    })
  }
  addFacilitatorJoiningOptionsEventListener() {

    let facilitatorJoiningOptionsModal = document.getElementById('addFacilitatorStep2Modal');
    facilitatorJoiningOptionsModal.addEventListener('shown.bs.modal', function (event) {
    let button = event.relatedTarget
    let contactData = button.getAttribute('data-bs-facilitator')
    let data = JSON.parse(contactData);
    document.getElementById('joiningMethodSubtitle').innerHTML = 'How will ' + data.name + ' join the call?';
      document.getElementById('addFacilitator').setAttribute('data-value', contactData)
    })
    document.getElementById('facInput1').focus();
  }
  setContactsAndFacilitator(){
    this.setHiddenContactsField();
    console.table(this.contacts)
    this.contactListTarget.innerHTML = contactTemplate(this.contacts, 'scheduled--show');
    this.facilitatorListTarget.innerHTML = facilitatorTemplate(this.facilitators, 'scheduled--show') 
    this.contacts.forEach ((att) => {
      this.setAddButton(att.contact_id, false)
    });
    this.facilitators.forEach ((att) => {
      this.setAddButton(att.contact_id, false)
    });
  }


  setAddButton(contact_id, activate){
    let contactAddButton = document.getElementById(`contactAddButton${contact_id}`) || document.getElementById(`facilitatorAddButton${contact_id}`)
    if (contactAddButton) { 
      contactAddButton.innerHTML = activate ? '<i class="fas fa-plus me-1"></i> Add' : 'Added'
      contactAddButton.disabled = activate ? false : true
      if (!activate) {
        contactAddButton.setAttribute('aria-hidden', 'true');
      }
    }  
  }

  loadScheduledSessionParticipants() {
    this.contacts = this.savedContacts.filter((att) => !att.facilitator);
    this.facilitators = this.savedContacts.filter((att) => att.facilitator);
    this.setContactsAndFacilitator()
  }

  addContact(event) {
    let contact = JSON.parse(event.currentTarget.dataset.value)
    contact.dialout = document.getElementById('radioInput1').checked;
    let joinPrefs = document.getElementsByName('joining_preference');
    let joinPref;
    for (let i = 0; i < joinPrefs.length; i++) {
      if (joinPrefs[i].checked) {
        joinPref = joinPrefs[i].value;
      }
    }
    contact.joining_preference = joinPref;
    this.contacts.push(contact),
    document.getElementById('closeContactJoiningModal').click();
    document.getElementById('closeContactModal').click();
    document.getElementById('addContactModalLaunch').focus();
    this.setContactsAndFacilitator();
  }

  removeContact(event) {
    let index = parseInt(event.currentTarget.dataset.guestKey);
    let contact_id = this.contacts[index].contact_id;
    this.setAddButton(contact_id, true)
    this.contacts.splice(index, 1);
    this.setContactsAndFacilitator();
  }

  addFacilitator(event) {

    let facilitator = JSON.parse(event.currentTarget.dataset.value);
    let joinPrefs = document.getElementsByName('facilitator_joining_preference');
    let joinPref;
    for (let i = 0; i < joinPrefs.length; i++) {
      if (joinPrefs[i].checked) {
        joinPref = joinPrefs[i].value;
      }
    }
    facilitator.joining_preference = joinPref;
    facilitator.facilitator = true;
    this.facilitators.push(facilitator)
    document.getElementById('closeFacilitatorJoiningModal').click();
    document.getElementById('closeFacilitatorModal').click();
    document.getElementById('addFacilitatorModalLaunch').focus();
    this.setContactsAndFacilitator();
  }

  removeFacilitator(event) {
    let index = parseInt(event.currentTarget.dataset.guestKey);
    let contact_id = this.facilitators[index].contact_id;
    this.setAddButton(contact_id, true)
    this.facilitators.splice(index, 1);
    this.setContactsAndFacilitator();
  }

  sendEmail(event) {
    const index = parseInt(event.currentTarget.dataset.guestKey);
    const type = event.currentTarget.dataset.guestType;
    const guest = type === 'facilitator' ? this.facilitators[index] : this.contacts[index];

    // Store context for the modal confirmation
    this.pendingNotificationContactId = guest.contact_id;
    this.pendingNotificationButton = event.currentTarget;

    // Populate modal
    document.getElementById('sendNotificationContactName').textContent = guest.name;

    // Show/hide SMS option based on account capability
    const smsOption = document.getElementById('sendEmailAndSmsOption');
    if (this.scheduledSessionDetails.has_sms_reminders) {
      smsOption.classList.remove('d-none');
    } else {
      smsOption.classList.add('d-none');
    }

    // Show modal
    const modal = new bootstrap.Modal(document.getElementById('sendNotificationModal'));
    modal.show();
  }

  confirmSendEmail(event) {
    const notificationType = event.currentTarget.dataset.notificationType;
    const contactId = this.pendingNotificationContactId;
    const sessionId = this.scheduledSessionDetails.id;
    const accountId = window.location.pathname.split('/')[2];
    const csrfToken = document.querySelector('[name="csrf-token"]').getAttribute('content');

    // Close the modal
    const modalEl = document.getElementById('sendNotificationModal');
    const modal = bootstrap.Modal.getInstance(modalEl);
    modal.hide();

    fetch(`/accounts/${accountId}/scheduled/${sessionId}/send_invite_email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ contact_id: contactId, notification_type: notificationType })
    })
    .then(response => response.json())
    .catch(error => console.error('Error sending notification:', error));
  }

  setHiddenContactsField() {
    let contacts = this.contacts.concat(this.facilitators)
    this.contactsTarget.value = JSON.stringify(contacts)
  }

  createScheduledSessionForm(){
    let self = this;
    return FormValidation.formValidation(
      document.getElementById('createScheduledSessionForm'),
      {
        fields: {
          title: {
            selector: '[name="scheduled_session_form[summary]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Title is required'
              },
              stringLength: {
                max: 255,
                message: 'Title must be less than 255 characters'
              }
            }
          },
          startDate: {
            selector: '[name="scheduled_session_form[start_date]"]',
            validators: {
              notEmpty: {
                message: 'Start date is required'
              },
              callback: {
                callback: function() {
                  return {
                    valid: self.isStartTimeInFuture(),
                    message: 'Start date and time must be in the future'
                  }
                }
              }
            }
          },
          startTime: {
            selector: '[name="scheduled_session_form[start_time]"]',
            validators: {
              notEmpty: {
                message: 'Start time is required'
              },
              callback: {
                callback: function() {
                  return {
                    valid: self.isStartTimeInFuture(),
                    message: 'Start date and time must be in the future'
                  }
                }
              }
            }
          },
          duration: {
            selector: '[name="scheduled_session_form[duration]"]',
            validators: {
              notEmpty: {
                message: 'Duration is required'
              },
            }
          },
          frequency: {
            selector: '[name="scheduled_session_form[frequency]"]',
            validators: {
              notEmpty: {
                message: 'Frequency is required'
              }
            }
          }
        },
        plugins: {
          bootstrap5: new Bootstrap5({
            rowSelector: '.g-5'
          }),
          autoFocus: new AutoFocus(),
          submitButton: new FormValidation.plugins.SubmitButton(),
          aria: new FormValidation.plugins.Aria(),
      },
    })
  }

  setUpdateSeriesBooleanField(){
    this.updateSeriesTarget.value = this.rruleChanged || (this.recurring ? this.updateSeriesCheckboxTarget.checked : false)
  }

  updateConfirmationModal(rrule_changed){
    if (rrule_changed) {
      document.getElementById('updateSeriesToggle').classList.add('d-none')
      document.getElementById('updateSeriesAltText').classList.remove('d-none');
      document.getElementById('updateSeriesText').classList.add('d-none');
    } else {
      document.getElementById('updateSeriesToggle').classList.remove('d-none');
      document.getElementById('updateSeriesAltText').classList.add('d-none');
      document.getElementById('updateSeriesText').classList.remove('d-none');
    }
  }

  changeRrule(){
    if (this.frequencyTarget.value == this.rrule?.split('RRULE:')[1]) {
      this.rruleChanged = false;
      if (this.recurring) {this.updateConfirmationModal(false)}
    } else {
      this.rruleChanged = true;
      if (this.recurring) {this.updateConfirmationModal(true)}
    }
  }

  submitScheduledSession() {
    let self = this;
    document.getElementById("createScheduledSessionSubmit").disabled = true;
    this.createScheduledSessionForm.validate().then(function (status) { 
      if (status == 'Valid') {
        self.setUpdateSeriesBooleanField();
        document.getElementById("createScheduledSessionForm").submit();
      } else {
        document.getElementById("createScheduledSessionSubmit").disabled = false;
      }
    });
  }

  isStartTimeInFuture(){
    let [year, month, day] = this.startDateTarget.value.split('-').map(x => parseInt(x));
    let [hour, minute] = this.timePickerTarget.value.split(':');
    let selectedTime = new moment.tz(new Date(year, month - 1, day, Number(hour)+1, minute), this.timezone).toDate()
    let currentTime = new moment.tz(this.timezone).toDate();
    return selectedTime > currentTime
  }

  setModalInputsAutofocus(){
    let facilitatorModal = document.getElementById('addFacilitatorModal')
    let contactModal = document.getElementById('addContactModal')
    facilitatorModal.addEventListener('shown.bs.modal', function (event) {
      event.target.querySelector("[autofocus]").focus();
    })
    contactModal.addEventListener('shown.bs.modal', function (event) {
      event.target.querySelector("[autofocus]").focus();
    })
  }

  setTimePickerOptions(){
    const startHour = 0;
    const endHour = 24;

    let times = Array.from({
      length: endHour - startHour
      }, (_v, index) => {
        return [0,15,30,45].map((interval) => {
          return moment({
            hour: index,
            minute: interval
          })
          .add(startHour, 'hours')
          .format('HH:mm')
        })
    }).flat()

    let options = times.map ((time) => {
      return `<option value=${time}>${time}</option>`
    })
    this.timePickerTarget.innerHTML = options.join('');
    this.timePickerTarget.value = this.sessionTime;
  }

  setFrequencyOptions(initialize){
    [6, 5].forEach((element) => {this.frequencyTarget.remove(element)});
    let startDate = new Date(this.startDateTarget.value);
    if (startDate) {
      // nth named day of the month
      let nthWeekdayText = getWeekOfTheMonth(startDate);
      // let nthWeekdaySelectText = `${nthWeekdayText} of each month`
      let nthWeekdayRule = RRule.fromText(`Every month on the ${nthWeekdayText}`).toString().split("RRULE:")[1];
      
      [[nthWeekdayRule, "Every month"]].forEach((element) => {
        this.frequencyTarget.add(new Option(element[1], element[0]));
      });
      if (initialize) {this.frequencyTarget.value = this.rrule?.split('RRULE:')[1] || 'None'}
    }
  }

}